import { instance } from "api/apiBase";
import type {
  BoomProduct,
  BoomProductsResponse,
  UpsellEventPayload,
  UpsellSurface
} from "api/boom-products/types";

const PRODUCTS_URL = "/portal/v1/products";

export const boomProductsApi = {
  list: async (): Promise<BoomProductsResponse> => {
    const { data } = await instance.get<BoomProductsResponse>(PRODUCTS_URL);
    return data;
  },

  // The accepted price is echoed back so the API can refuse (409
  // `price_changed`) when the price moved after the modal was opened.
  enable: async ({
    key,
    acceptedAmountCents,
    acceptedUnit,
    surface
  }: {
    key: string;
    acceptedAmountCents: number;
    acceptedUnit: string;
    surface: UpsellSurface;
  }): Promise<BoomProduct> => {
    const { data } = await instance.post<{ product: BoomProduct }>(
      `${PRODUCTS_URL}/${encodeURIComponent(key)}/enable`,
      {
        accepted_amount_cents: acceptedAmountCents,
        accepted_unit: acceptedUnit,
        surface
      }
    );
    return data.product;
  },

  // Idempotent: a repeat returns the existing open request.
  request: async ({
    key,
    surface
  }: {
    key: string;
    surface: UpsellSurface;
  }): Promise<void> => {
    await instance.post(`${PRODUCTS_URL}/${encodeURIComponent(key)}/requests`, {
      surface
    });
  },

  trackEvent: async (payload: UpsellEventPayload): Promise<void> => {
    await instance.post("/portal/v1/upsell_events", payload);
  }
};
